import THEME from "../../../theme";
import { fs } from "../utils/styles";

function Zeile({ label, aktuell, vorher }) {
  const veraenderungProzent = vorher ? ((aktuell - vorher) / Math.abs(vorher)) * 100 : null;
  const besser = aktuell >= vorher;
  return (
    <tr>
      <td style={fs.td}>{label}</td>
      <td style={{ ...fs.td, textAlign: "right" }}>{aktuell.toFixed(2)} €</td>
      <td style={{ ...fs.td, textAlign: "right" }}>{vorher.toFixed(2)} €</td>
      <td style={{ ...fs.td, textAlign: "right", color: besser ? THEME.colors.success : THEME.colors.danger, fontWeight: 600 }}>
        {veraenderungProzent !== null ? `${veraenderungProzent >= 0 ? "+" : ""}${veraenderungProzent.toFixed(1)}%` : "–"}
      </td>
    </tr>
  );
}

export default function VergleichsTabelle({ aktuellePeriode, vormonat }) {
  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Vergleich zum Vormonat</h3>
      <div style={fs.tabelle}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr><th style={fs.th}>Kennzahl</th><th style={{ ...fs.th, textAlign: "right" }}>Dieser Monat</th><th style={{ ...fs.th, textAlign: "right" }}>Letzter Monat</th><th style={{ ...fs.th, textAlign: "right" }}>Veränderung</th></tr></thead>
          <tbody>
            <Zeile label="Einnahmen" aktuell={aktuellePeriode.einnahmen_betrieblich} vorher={vormonat.einnahmen_betrieblich} />
            <Zeile label="Ausgaben" aktuell={aktuellePeriode.ausgaben_betrieblich} vorher={vormonat.ausgaben_betrieblich} />
            <Zeile label="Gewinn" aktuell={aktuellePeriode.vorlaeufiges_betriebsergebnis} vorher={vormonat.vorlaeufiges_betriebsergebnis} />
          </tbody>
        </table>
      </div>
    </div>
  );
}
